import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";
import { BrotherAttributionService } from "../../../../_services/brother-attribution.service";

import { fromPromise } from "rxjs/observable/fromPromise";
import { TranslationService } from "../../../../_services/translation.service";
import { ITranslations } from "../../../../_models/ITranslations";
import { FamilyMemberWithSiblingsModel } from "../../brother-attribution-models/family-model";

@Component({
  selector: "brother-attribution-search-child",
  templateUrl: "./brother-attribution-search-child.component.html",
  styleUrls: [
    "brother-attribution-search-child.component.scss",
    "../../brother-attribution-child-selector/brother-attribution-child-selector.component.scss",
    "../../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
  ],
})
export class BrotherAttributionSearchChildComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput")
  public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;
  @Output("childSelected")
  public updateNewFamilyStatus: EventEmitter<FamilyMemberWithSiblingsModel> = new EventEmitter<FamilyMemberWithSiblingsModel>();

  constructor(
    private modalService: NgbModal,
    private brotherAttributionService: BrotherAttributionService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {}

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.brotherAttributionService.searchChildAndSiblingsByText(term)
        );
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.autoCompleteInput.nativeElement.value = "";
    const childSelected = $event.item as FamilyMemberWithSiblingsModel;

    this.updateNewFamilyStatus.emit(childSelected);
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brothers-attribution-page/brother-attribution-search-child/brother-attribution-search-child.component.ts